function isValidDateString(dateString: string) {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
}

export function formattedDate(dateString: string) {
  if (!isValidDateString(dateString)) {
    return '';
  }

  const date = new Date(dateString);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
}
